import { useSiteLang as useLang } from '../siteLang';

// Écran de chargement plein-page "à la winston.ie" — le smiley qui respire
// doucement + un label bilingue à points animés, sur fond clair ou sombre
// selon la page qui l'utilise. Pensé pour remplacer un simple <div/> vide
// ou un texte "Chargement..." brut pendant un fetch initial.
const T = {
    fr: { label: 'Chargement' },
    en: { label: 'Loading' },
    vi: { label: 'Đang tải' },
};

function LoadingScreen({ variant = 'light' }) {
    const { lang } = useLang();
    const t = T[lang] || T.fr;
    const isLight = variant === 'light';
    const bg = isLight ? '#ffffff' : '#0e1013';
    const textColor = isLight ? 'rgba(14,16,19,0.38)' : 'rgba(244,239,228,0.42)';

    return (
        <div
            style={{
                minHeight: '100vh', width: '100%',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                background: bg, gap: '22px',
            }}
        >
            <style>{`
                @keyframes winstonLoadingBreathe {
                    0%, 100% { transform: scale(1) rotate(0deg); opacity: 0.92; }
                    50% { transform: scale(1.07) rotate(-2deg); opacity: 1; }
                }
                .winston-loading-mark {
                    animation: winstonLoadingBreathe 1.8s ease-in-out infinite;
                }
                @keyframes winstonDotPulse {
                    0%, 80%, 100% { opacity: 0.18; transform: translateY(0); }
                    40% { opacity: 1; transform: translateY(-2px); }
                }
                .winston-loading-dot {
                    animation: winstonDotPulse 1.4s ease-in-out infinite;
                }
            `}</style>

            <img
                src="/winston-smiley-white.svg"
                alt="winston.ie"
                className="winston-loading-mark"
                style={{ height: 'clamp(44px, 8vw, 64px)', width: 'auto', display: 'block', filter: isLight ? 'invert(1)' : 'none' }}
            />

            <p
                style={{
                    display: 'flex', alignItems: 'baseline', gap: '3px', margin: 0,
                    fontFamily: 'Helvetica Neue, Arial, sans-serif', fontWeight: 700,
                    fontSize: '10.5px', letterSpacing: '0.24em', textTransform: 'uppercase',
                    color: textColor,
                }}
            >
                {t.label}
                <span style={{ display: 'inline-flex', gap: '2px', marginLeft: '2px' }}>
                    <span className="winston-loading-dot" style={{ animationDelay: '0s' }}>.</span>
                    <span className="winston-loading-dot" style={{ animationDelay: '0.2s' }}>.</span>
                    <span className="winston-loading-dot" style={{ animationDelay: '0.4s' }}>.</span>
                </span>
            </p>
        </div>
    );
}

export default LoadingScreen;